<template>
  <footer>
    <div v-if="Server.isFooter && !zendeskUrl.ko.error" class="footer-wrap">
      <div class="flybit-logo">
        <img src="../../assets/img/footer/flybit-logo-white.svg" alt="" />
        <p>한국디지털거래소</p>
      </div>
      <p class="customer-center">
        {{ $t("footer.customerCenterTime") }}(주말 및 공휴일 휴무)
      </p>
      <div class="time">
        전화상담 1522-1221 (09:30 ~ 18:30)<br />
        카카오톡 상담 (09:30 ~ 18:30)
      </div>

      <div class="button-wrap" flex>
        <a href="mailto:help@flybit.com" class="email-button">
          <div class="item-wrap" flex>
            <img src="../../assets/img/footer/icon-headset.svg" alt="" />
            <p>help@flybit.com</p>
          </div>
        </a>
        <a
          :href="zendeskUrl[$i18n.locale]['listingInquiries']"
          target="_blank"
          class="noti-button"
        >
          <div class="item-wrap" flex>
            <img src="../../assets/img/footer/icon-email.svg" alt="" />
            <p>{{ $t("gnb.customerSupport.menu.listingApplication") }}</p>
          </div>
        </a>
      </div>
      <!-- 회사이름 및 정보 -->
      <div class="company-info">
        <p v-html="$t('footer.address')" class="about"></p>
        <p class="reserved">
          2018-{{ thisYear }} Korea Digital Exchange Co., Ltd. ALL RIGHTS
          RESERVED.
        </p>
      </div>
      <!-- 하단 4개 링크 영역 -->
      <div
        class="bottom-link mt20"
        :class="{ ko: $i18n.locale == 'ko', ch: $i18n.locale == 'ch' }"
        flex
        fjb
      >
        <div class="one-third">
          <a :href="zendeskUrl[$i18n.locale]['term']" target="_blank">
            {{ $t("footer.termsOfUse") }}</a
          >
        </div>
        <div class="one-third">
          <a
            :href="zendeskUrl[$i18n.locale]['policy']"
            class="text-white"
            target="_blank"
          >
            {{ $t("footer.privacyPolicy") }}
          </a>
        </div>
        <div class="one-third">
          <a
            :href="zendeskUrl[$i18n.locale]['serviceOperationPolicy']"
            class="text-white"
            target="_blank"
          >
            {{ "영상정보처리기기" }}<br />
            {{ "운영ㆍ관리 방침" }}
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "Footer",
  data() {
    return {
      thisYear: moment().format("YYYY"),
    };
  },
  computed: {
    ...mapState(["Server"]),
    ...mapState("Firebase", ["zendeskUrl"]),
  },
  methods: {
    goWeb() {
      CookieControl.setCookie("_agent", "web");

      location.replace(location.href.replace("m.", ""));
    },
  },
};
</script>

<style lang="scss" scoped>
@media (min-width: 330px) {
  .one-third {
    /* width: 102px; */
  }
}
@media (min-width: 281) and (max-width: 330px) {
  .one-third {
    /* width: 90px; */
  }
}
@media (min-width: 0) and (max-width: 280px) {
  .one-third {
    // flex: 1;
  }
}
p {
  margin-bottom: 0;
}
footer {
  .footer-wrap {
    padding: 34px 20px 95px;
    text-align: left;
    color: #fff;
    background-color: #000;
    .flybit-logo {
      width: 100px;
      p {
        text-align: right;
        font-size: 10px;
        font-weight: normal;
      }
    }
    .customer-center {
      margin-top: 20px;
      font-size: 12px;
      font-weight: bold;
    }
    .time {
      margin-top: 8px;
      font-size: 12px;
      font-weight: normal;
      color: #999;
    }
    .button-wrap {
      margin-top: 20px;
      padding-bottom: 36px;
      display: flex;
      @media (min-width: 281px) {
        .email-button,
        .noti-button {
          display: flex;
          flex-basis: calc(50% - 5px);
          position: relative;
          width: 128px;
          height: 34px;
          color: #fff;
          border-radius: 2px;
          border: 1px solid #4e4e4e;
          justify-content: center;
          .item-wrap {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-weight: normal;
            img {
              display: flex;
              margin-right: 4px;
            }
          }
          &:hover {
            background-color: #4e4e4e;
          }
        }
      }
      @media (max-width: 280px) {
        .email-button,
        .noti-button {
          display: flex;
          flex-basis: calc(50% - 5px);
          position: relative;
          width: 128px;
          height: 34px;
          color: #fff;
          border-radius: 2px;
          border: 1px solid #4e4e4e;
          justify-content: center;
          .item-wrap {
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 5px;
            font-weight: normal;
            img {
              display: flex;
              margin-right: 4px;
            }
          }
          &:hover {
            background-color: #4e4e4e;
          }
        }
      }
      .noti-button {
        margin-left: 10px;
      }
    }

    .company-info {
      padding-top: 20px;
      font-size: 12px;
      font-weight: normal;
      color: #999;
      border-top: 1px solid #4e4e4e;
      .about {
        height: 58px;
      }
      .reserved {
        margin-top: 8px;
        font-size: 10px;
        font-weight: normal;
        color: #666;
      }
    }

    @media (max-width: 280px) {
      .bottom-link {
        a {
          flex-basis: 33.3%;
          display: flex;
          font-size: 12px;
          font-weight: normal;
          color: #999999;
          &.text-white {
            color: #fff;
          }
        }
        &.ko {
          justify-content: space-between;
        }
        &.ch {
          padding-right: 20px;
        }
      }
    }
    @media (min-width: 320px) {
      .bottom-link {
        a {
          display: flex;
          font-size: 12px;
          font-weight: normal;
          color: #999999;
          &.text-white {
            color: #fff;
          }
        }
        &.ko {
          justify-content: space-between;
        }
        &.ch {
          padding-right: 20px;
        }
      }
    }
    @media (max-width: 319px) {
      .bottom-link {
        a {
          display: flex;
          font-size: 12px;
          font-weight: normal;
          color: #999999;
          &.text-white {
            color: #fff;
          }
        }
        &.ko {
          justify-content: space-between;
        }
        &.ch {
          padding-right: 20px;
        }
      }
    }
  }
}
</style>
